export default class ClassificacaoFiscal {
    id: number | null;
    ativa: boolean;
    codigoInterno: string;
    descricao: string;
    ncm: string;
    cest: string | null;
    aliquotaIpiPadrao: number | null;
    cstIpiPadrao: string | null;
    codigoEnquadramentoIpiPadrao: string | null;
    cstPisPadrao: string | null;
    aliquotaPisPadrao: number | null;
    cstCofinsPadrao: string | null;
    aliquotaCofinsPadrao: number | null;
    cstIbsCbsPadrao: string | null;
    classificacaoTributariaPadrao: string | null;

    constructor(
        id: number | null = null,
        ativa = true,
        codigoInterno = '',
        descricao = '',
        ncm = '',
        cest: string | null = null,
        aliquotaIpiPadrao: number | null = null,
        cstPisPadrao: string | null = null,
        aliquotaPisPadrao: number | null = null,
        cstCofinsPadrao: string | null = null,
        aliquotaCofinsPadrao: number | null = null,
        cstIbsCbsPadrao: string | null = null,
        classificacaoTributariaPadrao: string | null = null,
        cstIpiPadrao: string | null = null,
        codigoEnquadramentoIpiPadrao: string | null = null
    ) {
        this.id = id;
        this.ativa = ativa;
        this.codigoInterno = codigoInterno;
        this.descricao = descricao;
        this.ncm = ncm;
        this.cest = cest;
        this.aliquotaIpiPadrao = aliquotaIpiPadrao;
        this.cstIpiPadrao = cstIpiPadrao;
        this.codigoEnquadramentoIpiPadrao = codigoEnquadramentoIpiPadrao;
        this.cstPisPadrao = cstPisPadrao;
        this.aliquotaPisPadrao = aliquotaPisPadrao;
        this.cstCofinsPadrao = cstCofinsPadrao;
        this.aliquotaCofinsPadrao = aliquotaCofinsPadrao;
        this.cstIbsCbsPadrao = cstIbsCbsPadrao;
        this.classificacaoTributariaPadrao = classificacaoTributariaPadrao;
    }
}
